import type { Category } from './types';

export const categories: Category[] = [
  {
    name: '科技数码',
    slug: 'tech',
    description: '前沿科技资讯、数码产品评测、AI人工智能动态',
    icon: 'ri-smartphone-line',
    articleCount: 42,
  },
  {
    name: '生活娱乐',
    slug: 'lifestyle',
    description: '生活方式、娱乐八卦、时尚潮流资讯',
    icon: 'ri-heart-line',
    articleCount: 56,
  },
  {
    name: '美食旅行',
    slug: 'food-travel',
    description: '美食探店、旅行攻略、各地风土人情',
    icon: 'ri-restaurant-line',
    articleCount: 38,
  },
  {
    name: '电影音乐',
    slug: 'entertainment',
    description: '电影推荐、音乐分享、文化评论',
    icon: 'ri-film-line',
    articleCount: 45,
  },
  {
    name: '运动健身',
    slug: 'sports',
    description: '运动技巧、健身指南、赛事资讯',
    icon: 'ri-run-line',
    articleCount: 31,
  },
  {
    name: '学习教育',
    slug: 'education',
    description: '学习资源、教育资讯、技能提升指南',
    icon: 'ri-book-open-line',
    articleCount: 49,
  },
];